export const DEFAULT_LOCALE = 'th'

export const LOCALES = ['en', 'th', 'ja', ''] as const
export type Locale = typeof LOCALES[number]

export const BLOG_LOCALES = ['th', '']
export const SELF_ASSESSMENT_LOCALES = ['th']

export const COOKIE_LOCALE = '_LOCALE_'

export const RESOURCE_LOCALES = ['th', '']
